import type { ReactNode } from "react";
import { useAuthStore } from "../lib/auth-store";
import { firebaseEnabled } from "../lib/firebase";

export function AuthGate({ children }: { children: ReactNode }) {
  const ready = useAuthStore((s) => s.ready);

  if (!firebaseEnabled) {
    return (
      <div className="mx-auto mt-20 max-w-md">
        <div className="glass neon-border rounded-2xl p-7 text-center">
          <h1 className="neon-text text-xl font-bold">설정 필요</h1>
          <p className="mt-3 text-sm text-slate-400">
            Firebase가 아직 설정되지 않았습니다. <code>.env.local</code>에{" "}
            <code>VITE_FIREBASE_*</code>
            값을 채우고 다시 시작해주세요.
          </p>
        </div>
      </div>
    );
  }

  if (!ready) {
    return <div className="mt-20 text-center font-mono text-sm text-cyan-300/70">로딩 중…</div>;
  }
  return <>{children}</>;
}
